module.exports = __webpack_public_path__ + "static/media/unid-white.50a3d6aa.svg";